import dayjs from "dayjs";

export const durationInDays = (startDate: string, endDate: string) : number => {
  return dayjs(endDate)?.diff(dayjs(startDate), 'days')
};
